import { useMemo } from "react"
import { Platform } from "react-native"
import { useAsyncSelector } from "src/hooks/useAsyncSelector"
import { useRefresher } from "src/hooks/useRefresher"
import { hasOrganizationNoticeSelector } from "src/recoil/selectors/bottomTab/hasOrganizationNoticeSelector"
import { unreadContactCountSelector } from "src/recoil/selectors/bottomTab/unreadContactCountSelector"
import { selectedMyOrganizationSelector } from "src/recoil/selectors/organization/selectedMyOrganizationSelector"
import { hasPreTeamMemberSelector } from "src/recoil/selectors/bottomTab/hasPreTeamMemberSelector"
import { unreadContactCountRequestIdState } from "src/recoil/atoms/bottomTab/unreadContactCountRequestIdState"
import { hasPreTeamMemberRequestIdState } from "src/recoil/atoms/bottomTab/hasPreTeamMemberRequestIdState"
import { hasServiceInformationSelector } from "src/recoil/selectors/bottomTab/hasServiceInformationSelector"
import { informationsRequestIdState } from "src/recoil/atoms/settings/informationsRequestIdState"
import { notificationsRequestIdState } from "src/recoil/atoms/home/notificationsRequestIdState"
import { hasUnreadThreadMessageSelectorFamily } from "src/recoil/selectors/contact/hasUnreadThreadMessageSelectorFamily"
import { hasOrganizationMatchingNoticeSelector } from "src/recoil/selectors/matching/hasOrganizationMatchingNoticeSelector"
import { notificationsSelector } from "src/recoil/selectors/home/notificationsSelector"

export const useBottomTabBadgeData = () => {
  const { value: hasOrganizationNotice } = useAsyncSelector(hasOrganizationNoticeSelector)
  const refreshHasOrganizationNotice = useRefresher(notificationsRequestIdState)

  const { value: selectedOrganization } = useAsyncSelector(selectedMyOrganizationSelector)
  const organizationId = useMemo(() => selectedOrganization?.id, [selectedOrganization])
  const { value: hasUnreadThreadMessage } = useAsyncSelector(hasUnreadThreadMessageSelectorFamily({ organizationId }))
  const isShowInterstitialAd = useMemo(
    () =>
      Platform.OS !== "web" &&
      selectedOrganization &&
      (!selectedOrganization.paidFunctionEnabled || selectedOrganization.showAdsFlg),
    [selectedOrganization]
  )

  const { value: _unreadContactCount } = useAsyncSelector(unreadContactCountSelector)
  const unreadContactCount = useMemo(
    () => (_unreadContactCount != null ? Object.values(_unreadContactCount).reduce((l, r) => l + r, 0) : undefined),
    [_unreadContactCount]
  )
  const refreshUnreadContactCount = useRefresher(unreadContactCountRequestIdState)

  const { value: hasPreTeamMemberByTeam } = useAsyncSelector(hasPreTeamMemberSelector)
  const refreshHasPreTeamMember = useRefresher(hasPreTeamMemberRequestIdState)
  const hasPreTeamMember = useMemo(
    () => Object.values(hasPreTeamMemberByTeam || {}).some((bool) => bool),
    [hasPreTeamMemberByTeam]
  )

  const { value: hasServiceInformation } = useAsyncSelector(hasServiceInformationSelector)
  const refreshHasServiceInformation = useRefresher(informationsRequestIdState)

  const { value: hasOrganizationMatchingNotice } = useAsyncSelector(hasOrganizationMatchingNoticeSelector)
  const { value: notifications } = useAsyncSelector(notificationsSelector)

  return {
    hasOrganizationNotice,
    refreshHasOrganizationNotice,
    unreadContactCount,
    refreshUnreadContactCount,
    hasPreTeamMember,
    refreshHasPreTeamMember,
    notifications,
    hasServiceInformation,
    refreshHasServiceInformation,
    hasUnreadThreadMessage,
    hasOrganizationMatchingNotice,
    isShowInterstitialAd,
  }
}
